import { render, staticRenderFns } from "./BirthdayTemplate.vue?vue&type=template&id=40445047&scoped=true&"
import script from "./BirthdayTemplate.vue?vue&type=script&lang=js&"
export * from "./BirthdayTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayTemplate.vue?vue&type=style&index=0&id=40445047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40445047",
  null
  
)

export default component.exports